import { createStyles, Container, Group, Anchor, rem, Image, Badge, ActionIcon } from '@mantine/core';
import { MantineLogo } from '@mantine/ds';
import { Link } from 'react-router-dom';
import { IconBrandFacebook, IconBrandInstagram, IconBrandDiscord } from '@tabler/icons-react';
import logo from '../PB001b_ComedySeen_090723_logo(1).png'


const useStyles = createStyles((theme) => ({
  footer: {
    marginTop: rem(120),
    borderTop: `${rem(1)} solid ${theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[5]
      }`,
  },

  inner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,

    [theme.fn.smallerThan('xs')]: {
      flexDirection: 'column',
    },
  },

  links: {
    [theme.fn.smallerThan('xs')]: {
      marginTop: theme.spacing.md,
    },
  },

  socials: {
    [theme.fn.smallerThan('xs')]: {
      marginTop: theme.spacing.md,
    },
  },
}));

interface FooterSimpleProps {
  links: { link: string; label: string }[];
}

export default function Footer({ links }: FooterSimpleProps) {
  const { classes } = useStyles();
  const items = links.map((link) => (
    <Anchor
      color="dimmed"
      key={link.label}
      href={link.link}
      //onClick={(event) => event.preventDefault()}
      size="sm"
    >
      <Link to={link.link}>{link.label}</Link>
    </Anchor>
  ));

  return (
    <div className={classes.footer}>
      <Container className={classes.inner}>
        <Group spacing="xs">
          <Anchor href="/">
            <Image src={logo} fit="contain" width={100} />
          </Anchor>
          <Badge color="grape" variant="filled" size="md" radius="sm">
            Since 2022
          </Badge>
        </Group>
        <Group className={classes.links}>{items}</Group>
        <Group spacing={0} className={classes.socials} position="right" noWrap>
          <ActionIcon size="lg" component="a" href="https://www.facebook.com/groups/382439288137655" target="_blank" color="gray" variant="subtle">
            <IconBrandFacebook size="1.25rem" stroke={1.5} />
          </ActionIcon>
          <ActionIcon size="lg" component="a" href="https://www.instagram.com/getcomedyseen" target="_blank" color="gray" variant="subtle">
            <IconBrandInstagram size="1.25rem" stroke={1.5} />
          </ActionIcon>
          <ActionIcon size="lg" component="a" href="https://discord.gg/CT66bcwRNp" target="_blank" color="gray" variant="subtle">
            <IconBrandDiscord size="1.25rem" stroke={1.5} />
          </ActionIcon>
        </Group>
      </Container>
    </div>
  );
}
